import React, { useEffect,useState } from 'react';
import { Card, Empty, notification, Space, Table, Tag ,Select, Popconfirm ,Button} from 'antd';
import moment from 'moment-timezone';
import { useTradelogsMutation } from '../../slices/zerodhaApiSlice';
import { setTradelogs } from '../../slices/tradelogsSlice';
import { useDispatch, useSelector } from 'react-redux';

import { useAssignStrategyMutation, useGetAllStrategyQuery } from '../../slices/strategyApiSlice';
moment.tz.setDefault("Asia/Calcutta|Asia/Kolkata");


// Utility to format currency values
const formatCurrency = (value) => {
  const num = typeof value === 'object' && value?.$numberDecimal
  ? Number(value.$numberDecimal)
  : Number(value);
  return isNaN(num) ? "--" : `₹ ${num.toFixed(2)}`;
};

// Utility to format profit with tag color
const formatProfit = (value) => {
  const num = typeof value === 'object' && value?.$numberDecimal
  ? Number(value.$numberDecimal)
    : Number(value);
  const color = isNaN(num) ? "default" : num > 0 ? "green" : "red";
  return <Tag color={color}>{isNaN(num) ? "--" : `₹ ${num.toFixed(2)}`}</Tag>;
};
const TradeLogsTradeTable = () => {

const columns = [
  {
    title: 'Open Time',
    dataIndex: 'opening_date',
    key: 'opening_date',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    render: (value) => <a>{moment.utc(value).format("h:mm:ss A")}</a>,
  },
  {
    title: 'Symbol',
    dataIndex: 'symbol',
    key: 'symbol',
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    
  },
  // {
  //   title: 'ISIN',
  //   dataIndex: 'isin',
  //   key: 'isin',
  //   onCell: () => ({
  //     style: {
  //       whiteSpace: 'nowrap',
  //     },
  //   }),
  // },
  {
    title: 'Trade Date',
    dataIndex: 'opening_date',
    key: 'instrument',
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
  render: (value) => <a>{moment(value).utc(value).format("YYYY-MM-DD")}</a>,
  },
  {
    title: 'Segment',
    dataIndex: 'segment',
    key: 'segment',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
  },
  // {
  //   title: 'Series',
  //   dataIndex: 'series',
  //   key: 'series',
  //   onHeaderCell: () => ({
  //     style: {
  //       whiteSpace: 'nowrap',
  //     },
  //   }),
  //   onCell: () => ({
  //     style: {
  //       whiteSpace: 'nowrap',
  //     },
  //   }),
  // },
  {
    title: 'Trade Type',
    dataIndex: 'trade_type',
    key: 'trade_type',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    render: (value) => <a>{value == "buy" ? <Tag color="green">BUY</Tag> : <Tag color="red">SELL</Tag>}</a>,
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
  },
  {
    title: 'Auction',
    dataIndex: 'auction',
    key: 'auction',
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    render: (value) => <a>{value ? "True" : "False"}</a>,
  },
  {
    title: 'Buy Value',
    dataIndex: 'buy_value',
    key: 'buy_value',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    // render: (value) => <span>₹ {Number(parseFloat(value['$numberDecimal'])).toFixed(2)}</span>,
    render: (value) => <span>{formatCurrency(value)}</span>,

  },
  {
    title: 'Sell Value',
    dataIndex: 'sell_value',
    key: 'sell_value',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    // render: (value) => <span>₹ {Number(parseFloat(value['$numberDecimal'])).toFixed(2)}</span>,
       render: (value) => <span>{formatCurrency(value)}</span>,

  },
  {
    title: 'opening_price',
    dataIndex: 'opening_price',
    key: 'opening_price',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    // render: (value) => <span>₹ {Number(parseFloat(value['$numberDecimal'])).toFixed(2)}</span>,
    render: (value) => <span>{formatCurrency(value)}</span>,


  },
  {
    title: 'closing_price',
    dataIndex: 'closing_price',
    key: 'closing_price',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    // render: (value) => <span>₹ {Number(parseFloat(value['$numberDecimal'])).toFixed(2)}</span>,
     render: (value) => <span>{formatCurrency(value)}</span>,


  },
  {
    title: 'Profit',
    dataIndex: 'profit',
    key: 'profit',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    render: (value) => formatProfit(value),
  },
  {
    title: 'closing_date',
    dataIndex: 'closing_date',
    key: 'closing_date',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    render: (value) => <a>{moment.utc(value).format("YYYY-MM-DD h:mm:ss A")}</a>,
  },
    {
    title: 'broker_code',
    dataIndex: 'broker_code',
    key: 'broker_code',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
  },
 {
  title: "Strategy",
  dataIndex: "strategy_id",
  render: (value, record) => (
    <Space>
   <Select
  style={{ width: 140 }}
  placeholder="Select"
  options={strategyOptions}
  value={rowStrategy[record._id] || value}
  onChange={(val) => {
    setRowStrategy(prev => ({
      ...prev,
      [record._id]: val
    }));
  }}
/>

    <Popconfirm
  title="Assign strategy?"
  onConfirm={() =>
    handleAssignStrategy(
      record._id,
      rowStrategy[record._id] || value
    )
  }
>
  <Button
    type="primary"
    size="small"
    disabled={!rowStrategy[record._id]}
  >
    Assign
  </Button>
</Popconfirm>
    </Space>
  )
}
];

  const [api, contextHolder] = notification.useNotification();
const [rowStrategy, setRowStrategy] = useState({});
const { date } = useSelector((state) => state.date);
const { tradelogs } = useSelector((state) => state.tradelogs);

const [tradeLogs, { isLoading: isTradeLogsLoading }] = useTradelogsMutation();
// console.log("tradelog",tradeLogs);
// const [strategies, setStrategies] = useState([]);

// useEffect(() => {
//   fetch("/api/strategy")
//     .then(res => res.json())
//     .then(data => setStrategies(data));
// }, []);

const { data: strategies = [] } = useGetAllStrategyQuery();
const [assignStrategy] = useAssignStrategyMutation();
// const { data: strategies } = useGetAllStrategyQuery();
// const [assignStrategy] = useAssignStrategyMutation();

const strategyOptions = strategies?.data?.map((s) => ({
  value: s.id,
  label: s.name,
})) || [];
const dispatch = useDispatch();

const getTradeLogs = async (startDate, endDate) => {
    try {
      const res = await tradeLogs({ startDate, endDate }).unwrap();
console.log("tradelog",res);

      dispatch(setTradelogs({ ...res }));
    } catch (err) {
      console.log(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
}



const handleAssignStrategy = async (tradeId, strategyId) => {
  try {
    await assignStrategy({
      trade_id: tradeId,
      strategy_id: strategyId
    }).unwrap();

    notification.success({
      message: "Strategy assigned"
    });

  } catch (err) {
    notification.error({
      message: "Assign failed"
    });
  }
};

useEffect(()=> {
  getTradeLogs(date.startDate, date.endDate);
},[date])
  return (

    <> 
    {contextHolder}
    <Card bordered={false} className='card_hover' loading={isTradeLogsLoading}>
{ Array.isArray(tradelogs?.trades) && tradelogs.trades.length > 0 ? (
        <Table 
          columns={columns}
          dataSource={tradelogs.trades}
          rowKey={( record ) => record._id}   
          size='small' 
          style={{width: "100%"}} 

          tableProps={{ tableLayout: "fixed"}} 
          scroll={{x: "scroll"}} 
          headerColor/>
      ):(
      <>
        <Empty />
      </>
      )} 
    </Card>
    </>
);

}
export default TradeLogsTradeTable;